export const buildDownloadUrl = (
  artifactKey: string,
  version: string,
  downloadTraceId?: string,
): string => {
  const params = new URLSearchParams({ artifactKey, version });

  if (downloadTraceId) {
    params.set('downloadTraceId', downloadTraceId);
  }

  // If local, use the local mock server
  if (import.meta.env.DEV) {
    return `http://localhost:3001/internal-operations/software-distribution/download?${params.toString()}`;
  }
  // Otherwise, use the CloudFront URL
  return `/download?${params.toString()}`;
};

export const formatFileSize = (bytes: number): string => {
  const kilobytes = bytes / 1024;

  if (kilobytes < 1024) {
    return `${kilobytes.toFixed(1)} KB`;
  }

  const megabytes = kilobytes / 1024;

  return `${megabytes.toFixed(1)} MB`;
};
